import * as React from 'react';
export var LayoutTargetContext = React.createContext('aside');
export var LayoutTargetProvider = LayoutTargetContext.Provider;